import React from "react";
import Button from "@mui/material/Button";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Box from "@mui/material/Box";

import AddIcon from "@mui/icons-material/Add";

import getChoiceOption from "./getChoiceOption";
import OptionDialog from "./OptionDialog";
import { useTranslation } from "react-i18next";
import OptionList from "./OptionList";

// onDragEnd
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export default function InputChoice(props) {
  const { t } = useTranslation();
  const {
    question,
    updateHandler,
    isSelected = false,
    selectedId = "",
    open = false,
    handleClose = () => {},
    disabled,
    onMouseDown = () => {},
    isDropDisabled = false,
    disabledOptionIds = [],
    allowOptionAdd = true
  } = props;
  const { options } = question;
  const updateOptionHandler = (newOptions) =>
    updateHandler({ options: newOptions });

  // Edit option
  const updateOption = (optionId, newValue) => {
    const newOpt = options.map((item) =>
      item.id === optionId ? newValue : item
    );
    //console.log(newOpt);
    updateOptionHandler(newOpt);
  };

  // Add new option
  const addOption = (index, option) => {
    const newOptions = options.slice(0);
    newOptions.splice(index + 1, 0, option);
    if (options.length > 0) onMouseDown(`${option.id}title`);
    updateOptionHandler(newOptions);
  };

  // Remove option
  const removeOption = (id) => {
    const removeArr = options.filter((questionTemp) => questionTemp.id !== id);
    updateOptionHandler(removeArr);
  };

  const handleAddOption = () => {
    addOption(
      options.length - 1,
      getChoiceOption({
        title: `${t("editor.placeholders.option")} ${options.length + 1}`,
        number: options.length + 1,
      })
    );
  };

  const handleAddOptionAfterIndex = (index) => {
    addOption(
      index,
      getChoiceOption({
        title: `${t("editor.placeholders.option")} ${options.length + 1}`,
        number: options.length + 1,
      })
    );
  };

  // Drag & Drop
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const newOptions = reorder(
      options,
      result.source.index,
      result.destination.index
    );

    updateOptionHandler(newOptions);
  };

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId="optionList"
          isDropDisabled={disabled || isDropDisabled}
        >
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <OptionList
                options={options}
                question={question}
                isSelected={isSelected}
                selectedId={selectedId}
                updateOption={updateOption}
                removeOption={removeOption}
                handleAddOptionAfterIndex={handleAddOptionAfterIndex}
                disabled={disabled}
                disabledOptionIds={disabledOptionIds}
                allowOptionAdd={allowOptionAdd}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        {isSelected && allowOptionAdd ? (
          <Box width="100%" textAlign="left" paddingLeft={2}>
            <Button
              onClick={handleAddOption}
              startIcon={<AddIcon />}
              disabled={disabled}
            >
              {t("editor.buttons.addOption")}
            </Button>
          </Box>
        ) : null}
      </DragDropContext>

      <OptionDialog
        open={open}
        handleClose={handleClose}
        handleOk={({ options, hasImages }) => {
          updateHandler({ options, hasImages });
          handleClose();
        }}
        options={options}
      />
    </div>
  );
}
